import { createApiCall } from 'lib/base';

const SYNC_STOCK_FUNDAMENTALS = 'SYNC_STOCK_FUNDAMENTALS';

// Enqueues a full manual sync via the existing async task queue and returns
// immediately -- a sync reads ~2000 GCS files sequentially and can take
// minutes. Whether it succeeded is tracked by the existing queue Prometheus
// metrics (task_id=load_stock_fundamental), not surfaced back here.
const syncStockFundamentalsApi = createApiCall(SYNC_STOCK_FUNDAMENTALS, () => ({
  endpoint: 'api/admin/stock-fundamentals/sync',
  method: 'POST',
}));

export default syncStockFundamentalsApi;
